import { PageLayout } from '../components/PageLayout';

export function Cookies() {
  return (
    <PageLayout
      title="Cookie Policy"
      metaTitle="Cookie Policy - Abrovinc"
      metaDescription="Understand how Abrovinc uses cookies to improve your website experience. Learn about cookie types, third-party cookies, and how to manage your preferences."
      metaKeywords="cookie policy, cookies, analytics, website tracking, privacy preferences, Abrovinc"
      metaUrl="https://abrovinc.com/cookies"
    >
      <p>
        <strong>Last updated:</strong> {new Date().getFullYear()}
      </p>

      <h2>1. What Are Cookies</h2>
      <p>
        Cookies are small text files that are stored on your computer or mobile device when you
        visit our website. They help us make your experience better by remembering your preferences
        and analyzing how you use our site.
      </p>

      <h2>2. Types of Cookies We Use</h2>

      <h3>Essential Cookies</h3>
      <p>
        These cookies are necessary for the website to function properly. They enable basic features
        like page navigation and access to secure areas of the website.
      </p>

      <h3>Analytics Cookies</h3>
      <p>
        We use analytics cookies to understand how visitors interact with our website. This helps us
        improve the user experience and optimize our content. We use services like:
      </p>
      <ul>
        <li>
          <strong>Cloudflare Analytics:</strong> For website performance and security analytics
        </li>
        <li>
          <strong>Google Analytics:</strong> For understanding visitor behavior and site usage
        </li>
      </ul>

      <h3>Functional Cookies</h3>
      <p>
        These cookies allow the website to remember choices you make (such as your language
        preference) and provide enhanced, more personal features.
      </p>

      <h2>3. Third-Party Cookies</h2>
      <p>Some cookies are placed by third-party services that appear on our pages:</p>
      <ul>
        <li>
          <strong>LinkedIn:</strong> For social media integration and professional networking
          features
        </li>
        <li>
          <strong>Google Fonts:</strong> For loading custom fonts to improve site appearance
        </li>
      </ul>

      <h2>4. Managing Cookies</h2>
      <p>You can control and manage cookies in various ways:</p>
      <ul>
        <li>
          <strong>Browser Settings:</strong> Most browsers allow you to refuse cookies or delete
          existing ones
        </li>
        <li>
          <strong>Opt-out Tools:</strong> Many advertising networks provide opt-out tools
        </li>
        <li>
          <strong>Cookie Preferences:</strong> You can adjust your cookie preferences at any time
          using our cookie consent tool
        </li>
      </ul>

      <h2>5. Cookie Consent</h2>
      <p>
        By continuing to use our website, you consent to our use of cookies as described in this
        policy. You can withdraw your consent at any time by adjusting your browser settings or
        using our cookie preference center.
      </p>

      <h2>6. Updates to This Policy</h2>
      <p>
        We may update this Cookie Policy from time to time to reflect changes in our practices or
        applicable laws. We will notify you of any significant changes by posting the updated policy
        on our website.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions about our use of cookies, please contact us at:
        <br />
        Email: info@abrovinc.com
        <br />
        Address: Umeå, Sweden
      </p>
    </PageLayout>
  );
}
